import React, { Component } from "react";
import { createSelector } from "reselect";
import { connect } from "react-redux";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon";
import IconButton from '@material-ui/core/IconButton';
import SimpleReactValidator from 'simple-react-validator';
import { messageActions } from "../../../../common/redux/actions";
import { globalService as gs } from "../../../../common/services";


class MessageComposer extends Component {

	constructor(props) {
		super(props);
		const { activeKey, } = props;
		this.state = {
			activeKey: activeKey,
			user_id: parseInt(gs.identity.user.id),
			createdAt: null,
			team: props.team,
			formField: {
				text: '',
			},
			loading: false,
			submitted: false,
		};
		this.validator = new SimpleReactValidator({
			autoForceUpdate: this,
			className: 'valid-feedback d-block text-danger',
		});
		this.initializeState = this.state;
	}

	componentWillMount = () => {
		const { activeKey } = this.state;
		let query = gs.db.ref(`UserMessageRecipient/${activeKey}`);
		query.on("value", (snap) => this.process(snap));
	}

	process(snap) {

		this.current = snap.val();
	}

	findUnRead = () => {
		const { recipients } = this.props;
		const user_id = parseInt(this.state.user_id);
		const recipientsData = gs.ObjectToArray(this.current.recipients);
		return recipientsData.map((recipient) => {
			const userId = recipient.id;
			let count = parseInt(recipient.unread);
			recipient.unread = (userId === user_id) ? 0 : (count + 1);
			return recipient;
		});
	};

	addAttachment = (attachment, createdAt) => {
		const { user_id, activeKey, current } = this.state;
		const { dispatch, } = this.props;
		const recipients = this.findUnRead();
		const params = {};
		params.text = attachment;
		params.recipients = gs.ObjectToArray(recipients);
		params.group = this.group;
		params.item = this.item;
		params.user_id = user_id;
		if (createdAt !== null) {
			params.created_at = createdAt;
		}
		params.attachment = attachment;
		dispatch(messageActions.sendMessageToFirebase(params, activeKey));
		this.setState(this.initializeState);
	};

	handleUpload = (e) => {
		// Create file metadata including the content type
		const files = e.target.files;
		const storage = gs.storage;
		const { activeKey } = this.state;
		const self = this;
		if (files !== null) {
			this.setState({ attachment: files, });
			let i = 0;
			for (let file of files) {
				i = i + 1;
				const mime = (file.type === null) ? 'application/octet-stream' : file.type;
				var metadata = { contentType: mime, };
				const createdAt = parseInt(Date.now()) + parseInt(i);
				const upload = storage.ref(`${activeKey}/${createdAt}/${file.name}`).put(file, metadata);
				upload.on('state_changed', this.progress, this.error, this.success);
				upload.then(function (snapshot) {
					let attachment = snapshot.ref.getDownloadURL();
					attachment.then(function (downloadURL) {
						self.addAttachment(downloadURL, createdAt);
					});
				});
			}
		}
	};

	handleChange = (e) => {
		let formField = { ...this.state.formField };
		formField[e.target.name] = e.target.value;
		this.setState({ formField });
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.setState({ submitted: true });
		const { formField, activeKey } = this.state;
		const recipients = this.findUnRead();
		const params = {};
		params.text = formField.text;
		params.recipients = gs.ObjectToArray(recipients);
		params.user_id = parseInt(this.state.user_id);
		params.group = this.current.group;
		params.item = this.current.item;
		params.attachment = null;
		if (this.validator.allValid()) {
			const { dispatch, } = this.props;
			dispatch(messageActions.sendMessageToFirebase(params, activeKey));
			this.setState(this.initializeState);
		}
	};

	render() {
		this.validator.purgeFields();
		const { formField, loading } = this.state;
		const { text, } = formField;
		return (<div className="footer">
			<form name="message" method="POST" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
				<textarea
					className="form-control"
					placeholder="Write a reply..."
					type="text" name="text" value={text}
					onChange={this.handleChange}
				/>
				{this.validator.message('text', text, 'required')}
				<input
					accept="*"
					id="icon-button-file"
					type="file"
					className="d-none"
					onChange={this.handleUpload}
				/>
				<label htmlFor="icon-button-file" className="mt-2 mr-1">
					<IconButton variant="contained" color="primary" aria-label="upload picture" component="span">
						<Icon className="fas fa-paperclip text-info"></Icon>
					</IconButton>
				</label>

				<div className="fab-loading">
					<Fab className="bg-primary text-white" type="submit" size="small" disabled={false} aria-label="add">
						<Icon size="22" className="far fa-paper-plane"></Icon>
					</Fab>
				</div>
			</form></div>);
	}
}

const processSelector = createSelector(
	state => state.process,
	process => process
);

const authenticationSelector = createSelector(
	state => state.authentication,
	authentication => authentication
);

const mapStateToProps = createSelector(
	processSelector,
	authenticationSelector,
	(process, authentication) => ({
		process,
		authentication
	})
);

export default connect(mapStateToProps)(MessageComposer);


